(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["futur-booking"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('futur-booking')) {
    customElements.define('futur-booking', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.copy = JSON.parse(this.querySelector('[data-booking-copy]').textContent);
        this.liveCalendar = this.dataset.liveCalendar === 'true';
        this.liveSlots = [];
        this.availabilityKey = null;
        this.availabilityVersion = 0;
        if (this.liveCalendar) Object.assign(this.copy, this.copy.liveCopy);
        this.mount = this.querySelector('.fb__mount');
        this.state = { step: 0, service: null, date: null, time: null, week: 0, confirmed: false, cancelled: false, fields: { name: '', email: '', country: 'NO', code: '', phone: '', message: '' } };
        this.pickupStorageKey = 'futur-booking:131309142098:pickup-prototype:v1';
        this.pickupRecords = [];
        const previewURL = new URL(location.href);
        if (!this.liveCalendar && previewURL.searchParams.get('reset_pickup_test') === '1') {
          this.savePickupRecords([]);
          previewURL.searchParams.delete('reset_pickup_test');
          history.replaceState(history.state, '', previewURL);
        }
        this.desktop = matchMedia('(hover: hover) and (pointer: fine)');
        const today = new Date();
        this.start = new Date(Date.UTC(today.getFullYear(), today.getMonth(), today.getDate() + 1));
        while (this.start.getUTCDay() !== 1) this.start.setUTCDate(this.start.getUTCDate() + 1);
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.addEventListener('click', event => this.onClick(event), options);
        this.addEventListener('input', event => this.onInput(event), options);
        this.addEventListener('change', event => this.onInput(event), options);
        this.addEventListener('submit', event => { event.preventDefault(); this.submit(); }, options);
        this.addEventListener('pointerover', event => {
          if (!this.desktop.matches || event.pointerType === 'touch') return;
          this.setHover(event.target.closest('[data-service]'));
        }, options);
        this.addEventListener('pointerleave', () => this.setHover(null), options);
        this.addEventListener('focusin', event => this.setHover(event.target.closest('[data-service]')), options);
        this.addEventListener('focusout', event => this.setHover(event.relatedTarget && this.contains(event.relatedTarget) ? event.relatedTarget.closest('[data-service]') : null), options);
        this.desktop.addEventListener('change', () => this.setHover(null), options);
        this.render(false);
      }
      disconnectedCallback() { this.controller?.abort(); this.classList.remove('fb--hover'); this.initialized = false; }
      escape(value) { return String(value ?? '').replace(/[&<>"']/g, character => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[character])); }
      t(key) { if (this.liveCalendar && key === 'mockDates') return this.escape(this.availabilityLoading ? this.copy.availabilityLoading : this.availabilityError ? this.copy.availabilityError : this.copy[key]); return this.escape(this.copy[key]); }
      number(value) { return String(value + 1).padStart(2, '0'); }
      service() { return this.copy.services.find(service => service.id === this.state.service); }
      formatDate(iso, options) { return new Intl.DateTimeFormat(this.copy.locale || 'nb-NO', { timeZone: 'UTC', ...options }).format(new Date(iso + 'T12:00:00Z')); }
      dateLabel(iso) { return this.formatDate(iso, { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' }); }
      mockDates() {
        return Array.from({ length: 7 }, (_, index) => {
          const date = new Date(this.start);
          date.setUTCDate(date.getUTCDate() + this.state.week * 7 + index);
          return { iso: date.toISOString().slice(0, 10), available: index !== 6 && (this.liveCalendar || !(this.state.week % 2 === 1 && index === 2)) };
        });
      }
      readPickupRecords() {
        try {
          const stored = JSON.parse(localStorage.getItem(this.pickupStorageKey) || '[]');
          if (Array.isArray(stored)) this.pickupRecords = stored.filter(record =>
            record && record.service === 'service' && typeof record.id === 'string' &&
            /^\d{4}-\d{2}-\d{2}$/.test(record.date) && Number.isInteger(record.start) &&
            record.end === record.start + 10 && typeof record.window === 'string');
        } catch {}
        return this.pickupRecords || [];
      }
      savePickupRecords(records) {
        this.pickupRecords = records;
        try { localStorage.setItem(this.pickupStorageKey, JSON.stringify(records)); } catch {}
      }
      completePickup() {
        if (!this.assignTime()) { this.state.exactTime = null; this.state.appointment = null; if (this.state.service !== 'service') this.state.time = null; this.go(2); return; }
        const appointment = this.state.appointment;
        const toMinutes = value => { const [hours, minutes] = value.split(':').map(Number); return hours * 60 + minutes; };
        const id = this.state.pickupBookingId || crypto.randomUUID();
        const records = this.readPickupRecords().filter(record => record.id !== id);
        records.push({ id, service: 'service', date: appointment.date, window: appointment.window, start: toMinutes(appointment.start), end: toMinutes(appointment.end) });
        this.savePickupRecords(records);
        this.state.pickupBookingId = id;
        this.state.confirmed = true;
        this.go(4);
      }
      clock(minutes) { return `${String(Math.floor(minutes / 60)).padStart(2,'0')}:${String(minutes % 60).padStart(2,'0')}`; }
      timeSlots(date = this.state.date, service = this.service(), busy = this.busyIntervals || []) {
        if (!date || !service) return [];
        if (this.liveCalendar && arguments.length < 3) return this.liveTimeSlots(date, service);
        const day = new Date(date + 'T12:00:00Z').getUTCDay();
        if (!Number.isInteger(day) || day === 0) return [];
        const close = day === 6 ? 17 * 60 : 18 * 60;
        const pickup = service.id === 'service';
        const duration = pickup ? 10 : service.duration;
        const occupied = pickup ? this.readPickupRecords().filter(record => record.id !== this.state.pickupBookingId) : [];
        const conflicts = [...busy, ...occupied].filter(interval => interval.date === date);
        return Array.from({ length: (close - 12 * 60) / 30 }, (_, index) => {
          const start = 12 * 60 + index * 30;
          const positions = Array.from({ length: pickup ? 3 : 1 }, (_, position) => start + position * 10)
            .filter(position => position + duration <= close && !conflicts.some(interval => position < interval.end && position + duration > interval.start))
            .map(position => ({ start: this.clock(position), end: this.clock(position + duration) }));
          return { time: this.clock(start), available: positions.length > 0, positions };
        });
      }
      assignTime() {
        const slot = this.timeSlots().find(slot => slot.time === this.state.time);
        const position = this.state.service === 'service' ? slot?.positions.find(position => position.start === this.state.exactTime) : slot?.positions[0];
        this.state.appointment = position ? { date: this.state.date, service: this.state.service, window: this.state.time, ...position } : null;
        return !!position;
      }
      startTime() {
        if (this.state.service === 'service') return this.state.exactTime || null;
        const appointment = this.state.appointment;
        return appointment && appointment.date === this.state.date && appointment.service === this.state.service && appointment.window === this.state.time ? appointment.start : this.state.time;
      }
      endTime() {
        const [hours, minutes] = this.startTime().split(':').map(Number);
        const end = hours * 60 + minutes + this.service().duration;
        return `${String(Math.floor(end / 60)).padStart(2,'0')}:${String(end % 60).padStart(2,'0')}`;
      }
      setHover(row) {
        if (this.state.step !== 0) row = null;
        this.classList.toggle('fb--hover', !!row);
        this.querySelectorAll('[data-service]').forEach(item => item.classList.toggle('is-active', item === row));
      }
      canVisit(step) {
        if (step === 0) return true;
        if (step === 1) return !!this.state.service;
        if (step === 2) return !!this.state.date;
        if (step === 3) return (!this.liveCalendar || (!this.availabilityLoading && !this.availabilityError && this.availabilityKey === this.liveKey())) && !!this.state.time && (this.state.service !== 'service' || !!this.state.exactTime);
        return this.state.confirmed;
      }
      location() {
        if (this.service().online) return `<div class="fb__location"><strong>${this.t('online')}</strong></div>`;
        return `<div class="fb__location">${this.copy.physical.map((line,index) => `<div>${index === 0 ? '<strong>' : ''}${this.escape(line)}${index === 0 ? '</strong>' : ''}</div>`).join('')}</div>`;
      }
      summary() {
        const service = this.service();
        return `<aside class="fb__summary" aria-label="${this.t('summary')}"><p class="fb__eyebrow">${this.t('summary')}</p><div class="fb__summary-rule"></div><h2 class="fb__summary-name">${this.escape(service.name)}</h2><p class="fb__summary-description">${this.escape(service.description)}</p><p class="fb__summary-duration">${service.duration} ${this.t('minutes')}</p>${this.state.date ? `<div class="fb__summary-when">${this.dateLabel(this.state.date)}${this.startTime() ? `<br>${this.startTime()}–${this.endTime()} · ${this.t('timezoneLabel')}` : ''}</div>` : ''}${this.location()}</aside>`;
      }
      actions(enabled = true, submit = false) {
        return `<div class="fb__actions"><button type="button" class="fb__text-button" data-action="back">← ${this.t('back')}</button><button type="${submit ? 'submit' : 'button'}" class="fb__primary" ${submit ? '' : 'data-action="continue"'} ${enabled ? '' : 'disabled'}>${submit ? this.t('confirm') : this.t('continue')} <span aria-hidden="true">→</span></button></div>`;
      }
      servicesView() {
        return `<div class="fb__services">${this.copy.services.map((service,index) => `<button type="button" class="fb__service" data-service="${service.id}" aria-pressed="${this.state.service === service.id}"><span class="fb__service-number">${this.number(index)}</span><span class="fb__service-name">${this.escape(service.name)}</span><span class="fb__service-description">${this.escape(service.description)}</span><span class="fb__service-duration">${service.duration} ${this.t('minutes')}</span><span class="fb__arrow" aria-hidden="true">⟶</span></button>`).join('')}</div>`;
      }
      datesView() {
        const dates = this.mockDates();
        const month = iso => this.formatDate(iso, { month: 'long', year: 'numeric' });
        const context = month(dates[0].iso) === month(dates[6].iso) ? month(dates[0].iso) : `${month(dates[0].iso)} – ${month(dates[6].iso)}`;
        return `<div><div class="fb__date-toolbar"><h2 class="fb__subheading">${context}</h2><div class="fb__week-actions"><button type="button" data-action="previous-week" aria-label="${this.t('previousWeek')}" ${this.state.week === 0 ? 'disabled' : ''}>←</button><button type="button" data-action="next-week" aria-label="${this.t('nextWeek')}">→</button></div></div><div class="fb__dates" role="group" aria-label="${context}">${dates.map(date => `<button type="button" class="fb__date" data-date="${date.iso}" aria-label="${this.dateLabel(date.iso)}${date.available ? '' : ', ' + this.t('unavailable')}" aria-pressed="${this.state.date === date.iso}" ${date.available ? '' : 'disabled'}><span class="fb__day">${this.formatDate(date.iso, { weekday: 'short' }).toUpperCase()}</span><span class="fb__day-number">${Number(date.iso.slice(-2))}</span><span class="fb__date-mark" aria-hidden="true">${this.state.date === date.iso ? '✓' : date.available ? '·' : '—'}</span></button>`).join('')}</div><div class="fb__legend"><span><i class="fb__dot"></i>${this.t('available')}</span><span><i class="fb__dot fb__dot--selected"></i>${this.t('selected')}</span><span>— ${this.t('unavailable')}</span></div><p class="fb__mock-note">${this.t('mockDates')}</p>${this.actions(!!this.state.date)}</div>`;
      }
      pickupSelector() {
        if (this.state.service !== 'service' || !this.state.time) return '';
        const slot = this.timeSlots().find(slot => slot.time === this.state.time);
        if (!slot) return '';
        const [hours, minutes] = slot.time.split(':').map(Number);
        const options = Array.from({ length: 3 }, (_, index) => this.clock(hours * 60 + minutes + index * 10));
        return `<div class="fb__pickup-selector"><p class="fb__eyebrow" id="fb-pickup-label">${this.t('pickupLabel')}</p><div class="fb__pickup-options" role="group" aria-labelledby="fb-pickup-label">${options.map(time => {
          const available = slot.positions.some(position => position.start === time);
          return `<button type="button" class="fb__pickup-option" data-exact-time="${time}" aria-pressed="${this.state.exactTime === time}" aria-label="${time}${available ? '' : ', ' + this.t('unavailable')}" ${available ? '' : 'disabled'}>${time}</button>`;
        }).join('')}</div></div>`;
      }
      timesView() {
        return `<div><h2 class="fb__subheading">${this.dateLabel(this.state.date)}</h2><div class="fb__times" role="group" aria-label="${this.t('timezoneLabel')}">${this.timeSlots().map(slot => `<button type="button" class="fb__time" data-time="${slot.time}" aria-label="${slot.time}${slot.available ? '' : ', ' + this.t('unavailable')}" aria-pressed="${this.state.time === slot.time}" ${slot.available ? '' : 'disabled'}>${slot.time}<span class="fb__time-mark" aria-hidden="true">${this.state.time === slot.time ? '✓' : ''}</span></button>`).join('')}</div>${this.pickupSelector()}<p class="fb__mock-note">${this.t('mockDates')} · ${this.service().duration} ${this.t('minutes')} · ${this.t('timezoneLabel')}</p>${this.actions(this.canVisit(3))}</div>`;
      }
      detailsView() {
        const fields = this.state.fields;
        return `<form class="fb__form" novalidate><div class="fb__fields"><div class="fb__field fb__field--wide"><label for="fb-name">${this.t('name')} *</label><input id="fb-name" name="name" autocomplete="name" required maxlength="150" value="${this.escape(fields.name)}"></div><div class="fb__field fb__field--wide"><label for="fb-email">${this.t('email')} *</label><input id="fb-email" name="email" type="email" autocomplete="email" required maxlength="254" value="${this.escape(fields.email)}"></div><div class="fb__field"><label for="fb-country">${this.t('country')}</label><select id="fb-country" name="country" autocomplete="tel-country-code">${this.copy.countries.map(country => `<option value="${country[0]}" ${fields.country === country[0] ? 'selected' : ''}>${this.escape(country[1])} +${country[2]}</option>`).join('')}<option value="OTHER" ${fields.country === 'OTHER' ? 'selected' : ''}>${this.t('otherCountry')}</option></select></div><div class="fb__field"><label for="fb-phone">${this.t('phone')} *</label><input id="fb-phone" name="phone" type="tel" autocomplete="tel-national" inputmode="tel" required maxlength="30" value="${this.escape(fields.phone)}"></div><div class="fb__field fb__field--wide" data-custom-code ${fields.country === 'OTHER' ? '' : 'hidden'}><label for="fb-code">${this.t('customCode')} *</label><input id="fb-code" name="code" type="tel" inputmode="tel" placeholder="+47" maxlength="5" value="${this.escape(fields.code)}" ${fields.country === 'OTHER' ? 'required' : ''}></div><div class="fb__field fb__field--wide"><label for="fb-message">${this.t('message')} · ${this.t('optional')}</label><textarea id="fb-message" name="message" rows="3" maxlength="2000" placeholder="${this.t('messageHint')}">${this.escape(fields.message)}</textarea></div></div><p class="fb__error" id="fb-error" role="alert" hidden></p>${this.actions(true,true)}<p class="fb__form-note">${this.t('formNote')}</p></form>`;
      }
      confirmedView() {
        return `<div class="fb__confirmation"><h2 class="fb__confirmation-date">${this.dateLabel(this.state.date)}</h2><p class="fb__confirmation-time">${this.startTime()}–${this.endTime()}</p><p class="fb__mock-note">${this.t('timezoneLabel')}</p>${this.location()}${this.service().online ? `<p class="fb__notice">${this.t('meetNote')}</p>` : ''}<p class="fb__confirmation-note">${this.t('confirmationNote')}</p><div class="fb__confirmation-actions"><button type="button" class="fb__text-button" data-action="calendar">${this.t('calendar')}</button><button type="button" class="fb__text-button" data-action="reschedule">${this.t('reschedule')}</button><button type="button" class="fb__text-button" data-action="cancel">${this.t('cancel')}</button></div><p class="fb__notice" data-calendar-notice role="status" hidden>${this.t('calendarNote')}</p><div class="fb__cancel" data-cancel hidden><h3 class="fb__subheading" tabindex="-1">${this.t('cancelTitle')}</h3><p>${this.t('cancelCopy')}</p><div class="fb__actions"><button type="button" class="fb__primary" data-action="confirm-cancel">${this.t('cancelConfirm')}</button><button type="button" class="fb__text-button" data-action="keep">${this.t('keep')}</button></div></div><p class="fb__account">${this.t('account')}</p></div>`;
      }
      render(focus = true) {
        this.setHover(null);
        const step = this.state.step;
        const heading = this.state.cancelled ? this.t('cancelled') : this.escape(this.copy.headings[step]);
        const intro = this.state.cancelled ? this.t('cancelledCopy') : this.escape(this.copy.intros[step]);
        let content;
        if (this.state.cancelled) content = `<div class="fb__actions"><button type="button" class="fb__primary" data-action="restart">${this.t('restart')} →</button></div>`;
        else if (step === 0) content = this.servicesView();
        else content = `<div class="fb__workspace">${this.summary()}${step === 1 ? this.datesView() : step === 2 ? this.timesView() : step === 3 ? this.detailsView() : this.confirmedView()}</div>`;
        this.mount.innerHTML = `<div class="fb__top"><nav aria-label="${this.t('progressLabel')}"><ol class="fb__progress">${this.copy.steps.map((label,index) => `<li><button type="button" data-step="${index}" ${index === step ? 'aria-current="step"' : ''} ${!this.canVisit(index) || this.state.cancelled ? 'disabled' : ''}><span class="fb__progress-number">${this.number(index)}</span>${this.escape(label)}</button></li>`).join('')}</ol></nav><span class="fb__prototype">${this.t('prototype')}</span></div><h1 class="fb__heading" tabindex="-1">${heading}</h1><p class="fb__intro">${intro}</p>${content}`;
        if (focus) this.querySelector('.fb__heading').focus({ preventScroll: true });
      }
      go(step) {
        if (!this.canVisit(step)) return;
        if (step < 4) this.state.confirmed = false;
        this.state.step = step;
        this.render();
        if (this.liveCalendar && step === 2) this.loadAvailability();
        this.scrollIntoView({ block: 'start', behavior: 'instant' });
      }
      renderKeepingFocus(selector) { this.render(false); this.querySelector(selector)?.focus({ preventScroll: true }); }
      onInput(event) {
        const input = event.target;
        if (!Object.prototype.hasOwnProperty.call(this.state.fields, input.name)) return;
        this.state.fields[input.name] = input.value;
        input.removeAttribute('aria-invalid');
        input.removeAttribute('aria-describedby');
        if (input.name === 'country') {
          this.querySelector('[data-custom-code]').hidden = input.value !== 'OTHER';
          this.querySelector('#fb-code').required = input.value === 'OTHER';
        }
      }
      onClick(event) {
        const button = event.target.closest('button');
        if (!button || !this.contains(button) || button.disabled) return;
        if (this.savingLive) return;
        const data = button.dataset;
        if (data.service) {
          this.state.appointment = null;
          this.state.exactTime = null;
          if (this.liveCalendar) { this.state.time = null; this.state.exactTime = null; this.availabilityKey = null; }
          this.state.service = data.service;
          this.go(1);
        } else if (data.date) {
          if (!this.mockDates().some(date => date.iso === data.date && date.available)) return;
          if (this.state.date !== data.date) { this.state.time = null; this.state.appointment = null; this.state.exactTime = null; }
          this.state.date = data.date;
          if (this.liveCalendar) this.availabilityKey = null;
          this.renderKeepingFocus(`[data-date="${data.date}"]`);
        } else if (data.exactTime) {
          const slot = this.timeSlots().find(slot => slot.time === this.state.time);
          if (this.state.service !== 'service' || !slot?.positions.some(position => position.start === data.exactTime)) return;
          this.state.exactTime = data.exactTime;
          this.assignTime();
          this.renderKeepingFocus(`[data-exact-time="${data.exactTime}"]`);
        } else if (data.time) {
          if (!this.timeSlots().some(slot => slot.time === data.time && slot.available)) return;
          if (this.state.service === 'service' && this.state.time !== data.time) { this.state.exactTime = null; this.state.appointment = null; }
          this.state.time = data.time;
          if (this.state.service !== 'service') this.assignTime();
          this.renderKeepingFocus(`[data-time="${data.time}"]`);
        } else if (data.step !== undefined) this.go(Number(data.step));
        else {
          switch (data.action) {
            case 'continue': this.go(this.state.step + 1); break;
            case 'back': this.go(this.state.step - 1); break;
            case 'previous-week': if (this.state.week > 0) this.state.week--; this.renderKeepingFocus('[data-action="previous-week"]'); break;
            case 'next-week': this.state.week++; this.renderKeepingFocus('[data-action="next-week"]'); break;
            case 'reschedule': if (this.liveCalendar) { this.state.time = null; this.state.exactTime = null; this.state.appointment = null; this.availabilityKey = null; } this.go(1); break;
            case 'calendar': this.querySelector('[data-calendar-notice]').hidden = false; break;
            case 'cancel': this.querySelector('[data-cancel]').hidden = false; this.querySelector('[data-cancel] h3').focus(); break;
            case 'keep': this.querySelector('[data-cancel]').hidden = true; this.querySelector('[data-action="cancel"]').focus(); break;
            case 'confirm-cancel': if (this.liveCalendar) { this.cancelLive(); break; } if (this.state.pickupBookingId) { this.savePickupRecords(this.readPickupRecords().filter(record => record.id !== this.state.pickupBookingId)); this.state.pickupBookingId = null; } this.state.cancelled = true; this.state.confirmed = false; this.render(); break;
            case 'restart': this.liveIdentity = null; this.liveBooking = null; this.pendingLive = null; this.availabilityKey = null; this.state = { step: 0, service: null, date: null, time: null, week: 0, confirmed: false, cancelled: false, fields: { name:'', email:'', country:'NO', code:'', phone:'', message:'' } }; this.render(); break;
          }
        }
      }
      liveKey() { return `${this.state.date}:${this.state.service}:${this.liveBooking?.id || ''}`; }
      liveTimeSlots(date, service) {
        if (this.availabilityKey === this.liveKey() && !this.availabilityLoading && !this.availabilityError && date === this.state.date && service.id === this.state.service) return this.liveSlots;
        return this.timeSlots(date, service, []).map(slot => ({ ...slot, available: false, positions: [] }));
      }
      async liveRequest(op, data, post = false) {
        const url = new URL('/apps/futur-booking', location.origin);
        url.searchParams.set('op', op);
        const options = { method: post ? 'POST' : 'GET', cache: 'no-store', credentials: 'same-origin', redirect: 'error', signal: AbortSignal.timeout(35000) };
        if (post) {
          options.body = JSON.stringify(data);
          const digest = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(options.body));
          url.searchParams.set('body_sha256', Array.from(new Uint8Array(digest), byte => byte.toString(16).padStart(2, '0')).join(''));
          options.headers = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
        } else Object.entries(data).forEach(([key, value]) => url.searchParams.set(key, value));
        const response = await fetch(url, options);
        const result = await response.json();
        if (!response.ok || result.ok !== true) { const error = new Error('Booking request failed'); error.code = result.error; throw error; }
        return result;
      }
      async loadAvailability() {
        const version = ++this.availabilityVersion, key = this.liveKey();
        const data = { date: this.state.date, service: this.state.service };
        if (this.liveBooking) Object.assign(data, { bookingId: this.liveIdentity.bookingId, manageToken: this.liveIdentity.manageToken });
        this.availabilityLoading = true; this.availabilityError = false; this.render(false);
        try {
          const result = await this.liveRequest('availability', data, !!this.liveBooking);
          if (version !== this.availabilityVersion || key !== this.liveKey()) return;
          if (result.date !== data.date || result.service !== data.service || !Array.isArray(result.slots)) throw new Error('Invalid availability');
          this.liveSlots = result.slots; this.availabilityKey = key;
          this.availabilityLoading = false;
          if (this.state.time && !this.assignTime()) { this.state.appointment = null; this.state.exactTime = null; if (this.state.service !== 'service') this.state.time = null; }
        } catch {
          if (version !== this.availabilityVersion || key !== this.liveKey()) return;
          this.availabilityError = true; this.availabilityKey = null;
        } finally {
          if (version === this.availabilityVersion && key === this.liveKey()) { this.availabilityLoading = false; if (this.state.step === 2) this.render(false); }
        }
      }
      liveError(error) {
        const message = error.code === 'time_unavailable' ? this.copy.timeUnavailable : error.code === 'booking_changed' ? this.copy.bookingChanged : error.code === 'booking_in_progress' ? this.copy.bookingInProgress : this.copy.bookingError;
        const target = this.querySelector('#fb-error') || this.querySelector('[data-calendar-notice]');
        if (target) { target.textContent = message; target.hidden = false; }
      }
      async completeLive() {
        if (this.savingLive || !this.assignTime()) return;
        if (!this.liveIdentity) this.liveIdentity = { bookingId: crypto.randomUUID(), manageToken: Array.from(crypto.getRandomValues(new Uint8Array(32)), byte => byte.toString(16).padStart(2, '0')).join('') };
        const op = this.liveBooking ? 'reschedule' : 'create';
        const data = { ...this.state.appointment, ...this.liveIdentity, fields: { ...this.state.fields }, ...(this.liveBooking ? { etag: this.liveBooking.etag } : {}) };
        const key = JSON.stringify({ op, data });
        if (!this.pendingLive || this.pendingLive.key !== key) this.pendingLive = { key, op, data: { ...data, operationId: crypto.randomUUID() } };
        this.savingLive = true;
        this.querySelectorAll('button, input, select, textarea').forEach(element => { element.disabled = true; });
        try {
          const result = await this.liveRequest(op, this.pendingLive.data, true);
          const booking = result.booking;
          if (!booking || booking.date !== data.date || booking.start !== data.start || booking.end !== data.end || booking.service !== data.service) throw new Error('Unexpected confirmation');
          this.liveBooking = booking; this.pendingLive = null;
          this.state.confirmed = true; this.go(4);
        } catch (error) { this.render(false); this.liveError(error); }
        finally { this.savingLive = false; }
      }
      async cancelLive() {
        if (this.savingLive || !this.liveBooking) return;
        const data = { ...this.liveIdentity, etag: this.liveBooking.etag };
        const key = JSON.stringify({ op: 'cancel', data });
        if (!this.pendingLive || this.pendingLive.key !== key) this.pendingLive = { key, data: { ...data, operationId: crypto.randomUUID() } };
        this.savingLive = true;
        this.querySelectorAll('button').forEach(button => { button.disabled = true; });
        try {
          const result = await this.liveRequest('cancel', this.pendingLive.data, true);
          if (!result.cancelled) throw new Error('Cancellation not confirmed');
          this.liveBooking = null; this.pendingLive = null;
          this.state.cancelled = true; this.state.confirmed = false; this.render();
        } catch (error) { this.render(false); this.liveError(error); }
        finally { this.savingLive = false; }
      }
      async submit() {
        if (this.state.step !== 3 || !this.state.service || !this.state.date || !this.state.time) return;
        const fields = this.state.fields;
        const errors = [];
        if (!fields.name.trim()) errors.push(['name','nameError']);
        const email = this.querySelector('#fb-email');
        if (!fields.email.trim() || !email.validity.valid) errors.push(['email','emailError']);
        if (fields.phone.replace(/\D/g,'').length < 5 || !/^[\d\s()+.\-]+$/.test(fields.phone.trim())) errors.push(['phone','phoneError']);
        if (fields.country === 'OTHER' && !/^\+?\d{1,4}$/.test(fields.code.trim())) errors.push(['code','customCodeError']);
        if (errors.length) {
          const error = this.querySelector('#fb-error');
          error.textContent = errors.map(([,key]) => this.copy[key]).join(' ');
          error.hidden = false;
          errors.forEach(([name]) => { const input = this.querySelector(`[name="${name}"]`); input.setAttribute('aria-invalid','true'); input.setAttribute('aria-describedby','fb-error'); });
          this.querySelector(`[name="${errors[0][0]}"]`).focus();
          return;
        }
        if (this.liveCalendar) { await this.completeLive(); return; }
        if (this.state.service === 'service') {
          if (this.completingPickup) return;
          this.completingPickup = true;
          try {
            if (navigator.locks) await navigator.locks.request(this.pickupStorageKey, () => this.completePickup());
            else this.completePickup();
          } finally { this.completingPickup = false; }
          return;
        }
        if (!this.assignTime()) { this.state.exactTime = null; this.state.appointment = null; if (this.state.service !== 'service') this.state.time = null; this.go(2); return; }
        this.state.confirmed = true;
        this.go(4);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["futur-collection"] && !Shopify.designMode) return;
  try {
    
function initFuturCollections(scope) {
  scope.querySelectorAll('.futur-card__secondary').forEach(image => {
    const ready = () => { if (image.naturalWidth) image.closest('.futur-card').classList.add('futur-card--ready'); };
    if (image.complete) ready(); else image.addEventListener('load', ready, { once: true });
  });
  scope.querySelectorAll('.futur-collection__controls:not(.is-enhanced)').forEach(form => {
    form.classList.add('is-enhanced');
    form.querySelector('[name="sort_by"]').addEventListener('change', () => form.requestSubmit());
    form.addEventListener('keydown', event => {
      if (event.key === 'Escape') {
        const details = form.querySelector('details');
        details.open = false;
        details.querySelector('summary').focus();
      }
    });
  });
}
initFuturCollections(document);
document.addEventListener('shopify:section:load', event => initFuturCollections(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["futur-custom-inquiry"] && !Shopify.designMode) return;
  try {
    
(() => {
  const enhance = (section) => {
    if (section.dataset.futurBound) return;
    section.dataset.futurBound = 'true';
    let attempts = 0;
    const attach = () => {
      if (!section.isConnected) return;
      const embed = section.querySelector('shopify-forms-embed');
      const root = embed?.shadowRoot;
      if (!root?.querySelector('form')) {
        if (++attempts < 240) setTimeout(attach, 250);
        return;
      }
      const style = document.createElement('style');
      style.dataset.futurInquiryPresentation = 'silver-v1';
      style.textContent = "[data-testid=\"form\"] { display: grid !important; grid-template-columns: repeat(6, minmax(0, 1fr)); gap: 14px 20px !important; reading-flow: grid-rows; }\n[data-testid=\"form\"] > * { grid-column: 1 / -1; min-width: 0; order: 7; }\n[data-testid=\"form\"] > div:has(> shop-lead-capture) { order: 0; }\n[data-testid=\"form\"] > div:has(> input[id=\"first_name\"]) { order: 1; grid-column: span 3; }\n[data-testid=\"form\"] > div:has(> input[id=\"email\"]) { order: 2; grid-column: span 3; }\n[data-testid=\"form\"] > div:has(input[type=\"tel\"]) { order: 3; }\n[data-testid=\"form\"] > div:has(> [id=\"custom#budsjett-selector-label\"]) { order: 4; grid-column: span 3; }\n[data-testid=\"form\"] > div:has(> [id=\"custom#materiale-selector-label\"]) { order: 5; grid-column: span 3; }\n[data-testid=\"form\"] > fieldset { order: 6; margin-top: 6px; }\n[data-testid=\"form\"] > div:has(> [id=\"custom#edelstener-selector-label\"]), [data-testid=\"form\"] > div:has(> [id=\"custom#hvis_diamanter_opprinnelse-selector-label\"]) { order: 8; grid-column: span 3; }\n[data-testid=\"form\"] > div:has(> input[id=\"custom#nsket_deadline_bekreftes_etter_vurdering\"]) { order: 9; }\n[data-testid=\"form\"] > div:has(> textarea) { order: 10; }\n[data-futur-upload-heading] { order: 11 !important; margin: 9px 0 0; font-size: 15px; line-height: 1.4; font-weight: 400; letter-spacing: .04em; }\n[data-testid=\"form\"] > div:has(input[type=\"file\"]) { order: 12; grid-column: span 2; }\n[data-testid=\"form\"] > button[type=\"submit\"] { order: 13; grid-column: 1 / -1 !important; width: 100% !important; min-height: 50px !important; justify-content: center; text-align: center; box-sizing: border-box; }\n[class*=\"_formHeader_\"] { margin-bottom: 26px !important; }\n[class*=\"_formHeader_\"] h2 { font-size: 20px !important; font-weight: 400 !important; letter-spacing: .04em; margin-bottom: 5px !important; }\n[class*=\"_formHeader_\"] p { font-size: 16px; line-height: 1.5; }\ninput:not([type=\"checkbox\"]):not([type=\"file\"]), textarea, button[aria-expanded] { border-radius: 0 !important; background: #f2efe8 !important; color: #171714 !important; box-shadow: 0 0 0 1px #c8c8c4 !important; }\ninput:not([type=\"checkbox\"]):not([type=\"file\"]) { height: 54px !important; min-height: 54px; box-sizing: border-box !important; width: 100%; }\ninput[type=\"tel\"][name=\"phone_number\"] { box-sizing: border-box; height: 54px; padding-top: 24px; padding-bottom: 8px; }\nbutton[aria-expanded] { min-height: 54px; }\nbutton[aria-labelledby*=\"custom#\"] { box-sizing: border-box; height: 64px; min-height: 64px; padding-top: 29px !important; padding-bottom: 9px !important; }\n[class*=\"_selectContainer_\"] > [class*=\"_label_\"] { position: absolute; z-index: 1; pointer-events: none; margin: 0; padding: 0; left: 16px; right: 28px; font-size: 11px !important; line-height: 14px; letter-spacing: .035em; top: 9px !important; }\n[class*=\"_formInputFieldLabel_\"] { font-size: 12px !important; letter-spacing: .025em; color: #52554f !important; }\ninput:focus, textarea:focus, button[aria-expanded]:focus-visible { box-shadow: 0 0 0 1px #1d2b22 !important; outline: 1px solid #1d2b22; outline-offset: 2px; }\ninput:hover, textarea:hover, button[aria-expanded]:hover { box-shadow: 0 0 0 1px #1d2b22 !important; }\ninput[aria-invalid=\"true\"], textarea[aria-invalid=\"true\"] { box-shadow: 0 0 0 1px var(--form-error-color) !important; }\n[id=\"custom#budsjett-selector-value\"]:empty::before { content: var(--futur-budget-placeholder); }\n[id=\"custom#materiale-selector-value\"]:empty::before { content: var(--futur-material-placeholder); }\nfieldset > div { display: grid !important; grid-template-columns: repeat(3, minmax(0, 1fr)); grid-auto-flow: column; grid-template-rows: repeat(3, auto); gap: 8px 20px; }\nfieldset legend { margin-bottom: 10px; font-size: 15px !important; letter-spacing: .035em; }\nfieldset label { margin: 0 !important; min-width: 0; }\nfieldset label span { font-size: 15px !important; letter-spacing: .04em; }\ninput[type=\"checkbox\"] { width: 15px !important; height: 15px !important; border-radius: 0 !important; border-color: #b8bdc2 !important; accent-color: #1d2b22; }\ntextarea { box-sizing: border-box; width: 100% !important; min-height: 104px; padding-top: 29px !important; font-size: 16px !important; resize: vertical; }\n[class*=\"_formFileInput_\"] > p { display: none; }\n[class*=\"_formFileInputField_\"] { min-height: 132px; height: auto !important; background: transparent !important; border: 1px dashed #b8bdc2 !important; border-radius: 0 !important; box-shadow: none !important; }\n[class*=\"_formFileInputField_\"]:hover, [class*=\"_formFileInputField_\"]:focus-within { border-color: #1d2b22 !important; }\n[class*=\"_formFileInputContent_\"] { box-sizing: border-box; min-height: 130px; padding: 15px 10px !important; display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 6px; text-align: center; overflow-wrap: anywhere; }\n[class*=\"_formFileInputContent_\"]::before { content: ''; display: block; width: 22px; height: 22px; background: #1d2b22; mask: url('data:image/svg+xml,%3Csvg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"black\" stroke-width=\"1.4\" stroke-linecap=\"round\" stroke-linejoin=\"round\"%3E%3Cpath d=\"M12 16V3m-4 4 4-4 4 4M5 13v7h14v-7\"/%3E%3C/svg%3E') center / contain no-repeat; }\n[class*=\"_formFileInputButton_\"] { padding: 0 !important; border: 0 !important; background: none !important; font-size: 13px !important; line-height: 1.5; letter-spacing: .035em; text-decoration: none !important; }\n[class*=\"_formFileInputContent_\"]::after { content: var(--futur-upload-note); white-space: pre-line; font-size: 12px; line-height: 1.45; }\nbutton[type=\"submit\"] { width: 100%; min-height: 50px; margin-top: 3px; border: 0 !important; border-radius: 0 !important; background: #1d2b22 !important; color: white !important; font: 600 11px/1.5 Arial, sans-serif !important; letter-spacing: .25em !important; text-transform: uppercase; }\nbutton[type=\"submit\"]:hover { background: #2e4235 !important; filter: none !important; }\nbutton[type=\"submit\"]:focus-visible { outline: 2px solid #1d2b22; outline-offset: 4px; }\nbutton[type=\"submit\"][aria-disabled=\"true\"] { opacity: .65; }\n[class*=\"_formDisclaimer_\"], [class*=\"_formDisclaimer_\"] p { text-align: center !important; font-size: 15px !important; line-height: 1.6 !important; color: #494a43; }\n[class*=\"_formDisclaimer_\"] { margin-top: 16px !important; padding: 0 !important; }\ndiv:has(> [role=\"listbox\"]) { top: 100% !important; bottom: auto !important; z-index: 20 !important; }\n[role=\"listbox\"] { background: #f2efe8 !important; border-radius: 0 !important; max-height: 250px; }\n@media (max-width: 600px) {\n  [data-testid=\"form\"] { grid-template-columns: 1fr; gap: 15px !important; }\n  [data-testid=\"form\"] > * { grid-column: 1 / -1 !important; }\n  fieldset > div { grid-template-columns: repeat(2, minmax(0, 1fr)); grid-template-rows: none; grid-auto-flow: row; gap: 12px 14px; }\n  fieldset label span { font-size: 14px !important; }\n  [class*=\"_formHeader_\"] h2 { font-size: 18px !important; }\n  [class*=\"_formHeader_\"] p { font-size: 15px; }\n  [class*=\"_formFileInputField_\"] { min-height: 114px; }\n  [class*=\"_formFileInputContent_\"] { min-height: 112px; }\n}\n";
      root.appendChild(style);
      embed.style.setProperty('--futur-upload-note', JSON.stringify(section.dataset.uploadNote).replaceAll('\\n', '\\a '));
      embed.style.setProperty('--futur-budget-placeholder', JSON.stringify(section.dataset.budgetPlaceholder));
      embed.style.setProperty('--futur-material-placeholder', JSON.stringify(section.dataset.materialPlaceholder));
      const setText = (selector, value) => {
        const el = root.querySelector(selector);
        if (el?.childNodes.length === 1 && el.firstChild.nodeType === Node.TEXT_NODE && el.firstChild.nodeValue !== value) el.firstChild.nodeValue = value;
      };
      const update = () => {
        setText('[id="label-first_name"]', 'NAVN *');
        setText('[id="label-email"]', 'E-POST *');
        setText('[id="custom#budsjett-selector-label"]', 'BUDSJETT *');
        setText('[id="custom#materiale-selector-label"]', section.dataset.materialLabel);
        setText('[id="label-custom#fortell_oss_om_iden_din"]', section.dataset.ideaLabel);
        const textarea = root.querySelector('textarea[name="custom#fortell_oss_om_iden_din"]');
        if (textarea && !textarea.id) textarea.id = textarea.name;
        const button = root.querySelector('button[type="submit"]');
        if (button && button.getAttribute('aria-disabled') !== 'true' && !button.children.length) {
          setText('button[type="submit"]', section.dataset.submitLabel);
        }
        const form = root.querySelector('[data-testid="form"]');
        const files = form?.querySelectorAll('input[type="file"]');
        if (files?.length && !form.querySelector('[data-futur-upload-heading]')) {
          const heading = document.createElement('h3');
          heading.dataset.futurUploadHeading = '';
          heading.textContent = section.dataset.uploadHeading;
          form.appendChild(heading);
        }
        files?.forEach((input, index) => {
          const field = input.closest('[class*="_formFileInput_"]');
          const label = field?.querySelector('[class*="_formFileInputButton_"]');
          const value = section.dataset.uploadLabel + ' ' + (index + 1);
          if (label?.firstChild?.nodeType === Node.TEXT_NODE && label.textContent === 'Add file') label.firstChild.nodeValue = value;
        });
      };
      update();
      let queued = false;
      const observer = new MutationObserver(() => {
        if (!section.isConnected) { observer.disconnect(); return; }
        if (queued) return;
        queued = true;
        queueMicrotask(() => { queued = false; update(); });
      });
      observer.observe(root, { childList: true, subtree: true });
      document.addEventListener('shopify:section:unload', (event) => {
        if (event.target.contains(section)) observer.disconnect();
      }, { once: true });
    };
    attach();
  };
  document.querySelectorAll('[data-futur-redesign]').forEach(enhance);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-futur-redesign]').forEach(enhance);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["futur-hover-categories"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('futur-hover-categories')) {
    customElements.define('futur-hover-categories', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.rows = Array.from(this.querySelectorAll('.futur-hc__row'));
        this.desktop = matchMedia('(min-width: 750px) and (hover: hover) and (pointer: fine)');
        this.version = 0;
        const headers = Array.from(document.querySelectorAll('.shopify-section-group-header-group'));
        const measureHeader = () => {
          const height = headers.reduce((sum, item) => sum + item.getBoundingClientRect().height, 0);
          if (headers.length) this.style.setProperty('--futur-hc-header-space', `${height}px`);
        };
        this.headerObserver = new ResizeObserver(measureHeader);
        headers.forEach(item => this.headerObserver.observe(item));
        measureHeader();
        this.addEventListener('pointerover', event => {
          if (!this.desktop.matches || event.pointerType === 'touch') return;
          const row = event.target.closest('.futur-hc__row');
          if (row && this.contains(row)) { this.hovered = row; this.activate(row); }
        }, options);
        this.addEventListener('pointerleave', () => {
          this.hovered = null;
          this.activate(this.focused || null);
        }, options);
        this.addEventListener('focusin', event => {
          this.focused = event.target.closest('.futur-hc__row');
          this.activate(this.focused);
        }, options);
        this.addEventListener('focusout', event => {
          this.focused = event.relatedTarget && this.contains(event.relatedTarget) ? event.relatedTarget.closest('.futur-hc__row') : null;
          this.activate(this.focused || this.hovered || null);
        }, options);
        this.desktop.addEventListener('change', () => {
          this.hovered = null;
          this.activate(null);
        }, options);
        document.addEventListener('shopify:block:select', event => {
          const row = this.rows.find(item => item.dataset.blockId === event.detail.blockId);
          if (row) this.activate(row);
        }, options);
        document.addEventListener('shopify:block:deselect', event => {
          if (this.rows.some(item => item.dataset.blockId === event.detail.blockId)) this.activate(null);
        }, options);
      }
      async activate(row) {
        if (row === this.active) return;
        this.active = row;
        const version = ++this.version;
        this.rows.forEach(item => item.classList.remove('is-visible'));
        this.rows.forEach(item => item.classList.toggle('is-active', item === row));
        const image = row && row.querySelector('.futur-hc__image');
        if (image && this.desktop.matches) {
          image.loading = 'eager';
          try { await image.decode(); } catch (_) {}
        }
        if (!this.isConnected || version !== this.version) return;
        this.rows.forEach(item => item.classList.toggle('is-visible', item === row && !!image));
      }
      disconnectedCallback() {
        this.controller.abort();
        this.headerObserver.disconnect();
        this.version++;
        this.active = null;
        this.hovered = null;
        this.focused = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["futur-jewelry-product"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('futur-jewelry'))customElements.define('futur-jewelry',class extends HTMLElement{
 connectedCallback(){
  if(this.ready)return;this.ready=true;
  const headerGroups=[...document.querySelectorAll('.shopify-section-group-header-group')];
  this.syncMediaHeight=()=>{
   if(matchMedia('(min-width:990px)').matches){
    const height=headerGroups.reduce((sum,element)=>sum+element.getBoundingClientRect().height,0);
    const fallback=Math.max(0,this.getBoundingClientRect().top);
    this.style.setProperty('--futur-header-height',Math.round(height||fallback||84)+'px');
   }
  };
  this.syncMediaHeight();addEventListener('resize',this.syncMediaHeight,{passive:true});
  if('ResizeObserver' in window){this.headerObserver=new ResizeObserver(this.syncMediaHeight);headerGroups.forEach(element=>this.headerObserver.observe(element))}
  this.variants=JSON.parse(this.querySelector('[data-variants]').textContent);this.labels=JSON.parse(this.querySelector('[data-labels]').textContent);this.form=this.querySelector('form');this.fields=[...this.querySelectorAll('[data-option-index]')];
  this.addEventListener('change',e=>{if(e.target.closest('[data-option-index]'))this.resolve(true)});
  this.form.addEventListener('submit',e=>{const v=this.resolve(false);if(!v?.available||!this.form.checkValidity()){e.preventDefault();this.querySelector('[data-error]').textContent=this.labels.invalid;const invalid=this.form.querySelector(':invalid');if(invalid)invalid.focus();}});
  this.form.noValidate=true;this.resolve(false);
 }
 showMedia(id){
  if(!id)return;
  const item=this.querySelector(`[data-media="${id}"]`);
  if(!item)return;
  const gallery=this.querySelector('[data-jewelry-gallery]');
  const stage=this.querySelector('[data-jewelry-stage]');
  const behavior=matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth';
  if(matchMedia('(min-width:990px)').matches)gallery.scrollTo({top:item.offsetTop,behavior});
  else stage.scrollTo({left:item.offsetLeft,behavior});
  this.querySelectorAll('video').forEach(video=>{if(!item.contains(video))video.pause()});
 }
 resolve(updateUrl){
  const values=this.fields.map(f=>f.querySelector('select')?.value??f.querySelector('input:checked')?.value);
  const v=this.fields.length?this.variants.find(v=>v.options.every((x,i)=>x===values[i])):this.variants[0];
  this.querySelector('[data-variant-id]').value=v?.id??'';
  const button=this.querySelector('[data-add]');button.disabled=!v?.available;button.textContent=v?(v.available?this.labels.add:this.labels.soldOut):this.labels.unavailable;
  this.querySelector('[data-price]').textContent=v?.price??this.labels.unavailable;const compare=this.querySelector('[data-compare]');compare.hidden=!v?.compare;compare.textContent=v?.compare??'';this.querySelector('[data-error]').textContent='';
  if(updateUrl&&v){const url=new URL(location.href);url.searchParams.set('variant',v.id);history.replaceState(history.state,'',url);if(v.media)this.showMedia(v.media)}
  return v;
 }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["futur-product-concept-b"]) return;
  try {
    
if(!customElements.get('futur-jewelry-concept'))customElements.define('futur-jewelry-concept',class extends HTMLElement{
 connectedCallback(){
  if(this.ready)return;this.ready=true;
  const headerGroups=[...document.querySelectorAll('.shopify-section-group-header-group')];
  this.syncMediaHeight=()=>{
   if(matchMedia('(min-width:990px)').matches){
    const height=headerGroups.reduce((sum,element)=>sum+element.getBoundingClientRect().height,0);
    const fallback=Math.max(0,this.getBoundingClientRect().top);
    this.style.setProperty('--futur-header-height',Math.round(height||fallback||84)+'px');
   }
  };
  this.syncMediaHeight();addEventListener('resize',this.syncMediaHeight,{passive:true});
  if('ResizeObserver' in window){this.headerObserver=new ResizeObserver(this.syncMediaHeight);headerGroups.forEach(element=>this.headerObserver.observe(element))}
  this.variants=JSON.parse(this.querySelector('[data-variants]').textContent);this.labels=JSON.parse(this.querySelector('[data-labels]').textContent);this.form=this.querySelector('form');this.fields=[...this.querySelectorAll('[data-option-index]')];
  this.addEventListener('change',e=>{if(e.target.closest('[data-option-index]'))this.resolve(true)});
  this.form.addEventListener('submit',e=>{const v=this.resolve(false);if(!v?.available||!this.form.checkValidity()){e.preventDefault();this.querySelector('[data-error]').textContent=this.labels.invalid;const invalid=this.form.querySelector(':invalid');if(invalid)invalid.focus();}});
  this.initColorViews();this.form.noValidate=true;this.resolve(false);
 }

 initColorViews(){
  const mappingNode=this.querySelector('[data-color-view-map]');
  if(!mappingNode)return;
  const mapping=JSON.parse(mappingNode.textContent);
  const items=[...this.querySelectorAll('[data-jewelry-gallery] [data-media]')];
  const groups=new Map();
  for(const item of items){
   const entry=mapping[item.dataset.media],img=item.querySelector('img');
   if(!entry||!img)return;
   if(!groups.has(entry.color))groups.set(entry.color,new Map());
   groups.get(entry.color).set(entry.view,{id:item.dataset.media,attributes:Object.fromEntries(['src','srcset','sizes','alt','width','height'].map(name=>[name,img.getAttribute(name)]))});
  }
  const views=items.slice(0,4).map(item=>mapping[item.dataset.media].view);
  if(views.length!==4||new Set(views).size!==4||groups.size!==3||[...groups.values()].some(group=>views.some(view=>!group.has(view))))return;
  this.colorViews=groups;
  this.colorSlots=items.slice(0,4).map((item,i)=>({item,view:views[i]}));
  items.slice(4).forEach(item=>item.remove());
 }
 updateColorViews(color){
  const group=this.colorViews?.get(color);
  if(!group||this.activeGoldColor===color)return;
  for(const {item,view} of this.colorSlots){
   const source=group.get(view),img=item.querySelector('img');
   for(const [name,value] of Object.entries(source.attributes)){
    if(value===null)img.removeAttribute(name);else img.setAttribute(name,value);
   }
   item.dataset.media=source.id;
   item.dataset.view=view;
   item.dataset.goldColor=color;
  }
  this.activeGoldColor=color;
 }

 showMedia(id){
  if(!id)return;
  const item=this.querySelector(`[data-media="${id}"]`);
  if(!item)return;
  const gallery=this.querySelector('[data-jewelry-gallery]');
  const stage=this.querySelector('[data-jewelry-stage]');
  const behavior=matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth';
  if(matchMedia('(min-width:990px)').matches)gallery.scrollTo({top:item.offsetTop,behavior});
  else stage.scrollTo({left:item.offsetLeft,behavior});
  this.querySelectorAll('video').forEach(video=>{if(!item.contains(video))video.pause()});
 }
 resolve(updateUrl){
  const values=this.fields.map(f=>f.querySelector('select')?.value??f.querySelector('input:checked')?.value);
  const metalLine=this.querySelector('[data-heading-metal]');
  const metalIndex=Number(metalLine?.dataset.metalIndex??-1);
  if(metalLine&&metalIndex>=0){metalLine.textContent=values[metalIndex]??'';metalLine.hidden=!metalLine.textContent;}
  const v=this.fields.length?this.variants.find(v=>v.options.every((x,i)=>x===values[i])):this.variants[0];
  this.querySelector('[data-variant-id]').value=v?.id??'';
  const button=this.querySelector('[data-add]');button.disabled=!v?.available;button.textContent=v?(v.available?this.labels.add:this.labels.soldOut):this.labels.unavailable;
  this.querySelector('[data-price]').textContent=v?.price??this.labels.unavailable;const compare=this.querySelector('[data-compare]');compare.hidden=!v?.compare;compare.textContent=v?.compare??'';this.querySelector('[data-error]').textContent='';
  if(v&&this.colorViews)this.updateColorViews(v.options[0]);
  if(updateUrl&&v){const url=new URL(location.href);url.searchParams.set('variant',v.id);history.replaceState(history.state,'',url);if(v.media&&!this.colorViews)this.showMedia(v.media)}
  return v;
 }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
